import { html, nothing } from "lit";
import { translate } from "../../../../localization";
import { ActivityHistoryPartialDataError } from "./component";

export const template = (props: ActivityHistoryPartialDataError) => {
  const combinedMessage = props.getCombinedMessage();

  return html`
    ${props.isErrorOccurred ? renderPartialErrorAlert(props, combinedMessage) : nothing}
  `;
};

const renderPartialErrorAlert = (props: ActivityHistoryPartialDataError, combinedMessage: string) => {
  return html`
    <div class="container">
      <dss-alert @onButtonClick=${props.handleClickAlert} state="warning" size="lg" message="${combinedMessage}" buttonLabel=${translate("error.partial.refresh")} hasbutton></dss-alert>
    </div>
  `;
};
